export enum OtherAssetsTypeOption {
	FurnitureFixtures = 'Furniture / Fixtures',
	Jewelry = 'Jewelry',
	Other = 'Other Personal Assets'
}
